// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const Collapsed = createIcon(
  <path
    clipRule="evenodd"
    d="M15.6892 7.3922C15.6892 6.89514 16.0921 6.49219 16.5892 6.49219C17.0862 6.49218 17.4892 6.89512 17.4892 7.39218L17.4893 16.628C17.4893 17.1251 17.0863 17.528 16.5893 17.528C16.0922 17.528 15.6893 17.1251 15.6893 16.6281L15.6892 7.3922ZM6.80857 8.03956C6.4571 7.68809 6.4571 7.11824 6.80857 6.76677C7.16005 6.4153 7.7299 6.4153 8.08137 6.76677L12.6778 11.3632C13.0293 11.7147 13.0293 12.2845 12.6778 12.636L8.08137 17.2324C7.7299 17.5839 7.16005 17.5839 6.80858 17.2324C6.4571 16.881 6.4571 16.3111 6.80857 15.9596L10.7686 11.9996L6.80857 8.03956Z"
    fillRule="evenodd"
  />,
);
